import { useDebounceFn } from '@vueuse/core';
<script lang="ts" setup>
	import { useDebounceFn } from '@vueuse/core'

	const { observeElementInViewport } = useInterSector()
	const { deviceType } = useMobile()
	const currentTab = shallowRef(0)
	const btnLabels = ref<HTMLButtonElement | null>(null)
	const cardWrapper = useTemplateRef('cardWrapper')

	const processess = ref([
		{
			active: true,
			label: 'Manage Your Business',
			title: 'Easy business management',
			bgClass: 'bg-travel-100',
			description:
				'Tailored features for business managers. Add or remove staff, and monitor submitted claims from your dashboard.',
			src: '/v1727082829/demo-1_fwkg00.gif'
		},
		{
			active: false,
			label: 'One Stop Shop',
			title: 'Diverse insurance options',
			bgClass: 'bg-health-100',
			description:
				'Like curating a playlist, our platform offers a range of insurance plans from health and gadgets to auto and travel.',
			src: '/v1727082831/demo-2_urxkfn.gif'
		},
		{
			active: false,
			label: 'Insure Effortlessly',
			title: 'Bulk upload hero',
			bgClass: 'bg-gadget-100',
			description:
				'Efficiently manage multiple staff, gadgets, and vehicles at once with our seamless batch processing feature.',
			src: '/v1727082835/demo-3_vwdiy1.gif'
		},
		{
			active: false,
			label: 'Data Detective',
			title: 'Gain valuable insights',
			bgClass: 'bg-auto-100',
			description:
				'Understand your insurance usage with insightful analytics that provide clarity and understanding.',
			src: '/v1727082828/demo-4_abou6k.gif'
		},
		{
			active: false,
			label: 'Monitor Activities',
			title: 'Track activities',
			bgClass: 'bg-error-100',
			description:
				'Stay informed about your teams’ hospital visits and claims with our intuitive Activity Tracker.',
			src: '/v1727082830/demo-5_ahcc23.gif'
		},
		{
			active: false,
			label: 'Team Management',
			title: 'Delegate like a genius',
			bgClass: 'bg-success-100',
			description: 'Assign roles and permissions to  other business managers. Share the control, not the stress.',
			src: '/v1727082826/demo-6_kds9ta.gif'
		}
	])
	const isLastItmeActive = computed(() => {
		return processess.value[processess.value.length - 1].active
	})

	const watchSteps = useDebounceFn(() => {
		if (deviceType.value !== 'desktop') {
			processess.value.forEach(item => {
				const title = document.querySelector(`[data-index="${item.title}"]`)
				if (title) {
					item.active = false
					return observeElementInViewport(
						title,
						isVisible => {
							if (isVisible && !item.active) {
								item.active = true
							}
						},
						1.0
					)
				}
			})
		}
	}, 500)

	const moveToViewPort = () => {
		if (btnLabels.value && cardWrapper.value) {
			const btnEl = btnLabels.value.querySelector('.selected-btn') as HTMLButtonElement
			const cardEl = cardWrapper.value.querySelector('.highlightedCard') as HTMLButtonElement

			if (btnEl && cardEl) {
				const { right } = btnEl.getBoundingClientRect()

				if (currentTab.value != 0) {
					btnLabels.value.scrollTo({
						left: right,
						behavior: 'smooth'
					})
					cardWrapper.value.scrollTo({
						left: cardEl.offsetWidth * currentTab.value,
						behavior: 'smooth'
					})
				} else {
					cardWrapper.value.scrollTo({
						left: 0,
						behavior: 'smooth'
					})
					btnLabels.value.scrollTo({
						left: 0,
						behavior: 'smooth'
					})
				}
			}
		}
	}
	const switchTab = (forward = true) => {
		processess.value[currentTab.value].active = false
		if (currentTab.value < processess.value.length - 1 && forward) {
			currentTab.value++
		} else if (!forward && currentTab.value > 0) {
			currentTab.value--
		}
		processess.value[currentTab.value].active = true
		moveToViewPort()
	}

	const getTab = (label: string) => {
		const itemIndex = processess.value.findIndex(item => item.label === label)
		// Turn off the previous index selected
		processess.value.forEach(item => (item.active = false))
		processess.value[itemIndex].active = true
		currentTab.value = itemIndex
		moveToViewPort()
	}
	onMounted(() => {
		if (cardWrapper.value) {
			cardWrapper.value.addEventListener('scroll', watchSteps)
		}
	})
	onUnmounted(() => {
		if (cardWrapper.value) {
			cardWrapper.value.removeEventListener('scroll', watchSteps)
		}
	})
	defineEmits<{
		(event: 'trigger', payload?: string): void
	}>()
</script>

<template>
	<section class="bg-[#FFD466] dark:bg-[#332500] w-full py-8 flexed flex-col justify-center items-center">
		<ui-pad :ui="{ paddingInline: 'sm:px-14 md:px-5 px-1' }" class="w-full">
			<div class="mx-auto w-full">
				<ui-title-header
					:ui="{ size: 'sm:text-[3.25em] text-[2em]', color: 'text-[#1A1200] dark:text-gray-300' }"
					class="text-center sm:text-left"
				>
					It's all digital
				</ui-title-header>

				<div class="flexed mt-8 items-center gap-6 justify-center sm:justify-between flex-wrap">
					<div
						class="gap-x-3 overflow-hidden overflow-x-auto invisible-scrollbar flexed pt-3"
						ref="btnLabels"
					>
						<button
							v-for="(item, index) in processess"
							:key="item.label"
							type="button"
							class="capitalize flex-none hover:sm:bg-white font-medium hover:sm:border-transparent hover:sm:text-[#1A1200] dark:hover:sm:text-[#1A1200] dark:text-gray-200 transition-colors ease-linear dark:border-gray-300 flexed sm:rounded-[200px] sm:w-auto h-[30px] w-[30px] xs:h-[32px] xs:w-[32px] justify-center border rounded-full custom-transition-2"
							:class="[
								item.active
									? 'selected-btn sm:text-base text-sm border-auto-950 text-auto-950   sm:h-[48px] sm:p-[12px_16px]'
									: 'text-xs border-[#332500] text-blue-950 sm:px-5'
							]"
							@click="getTab(item.label)"
						>
							<span class="sm:inline hidden">
								{{ item.label }}
							</span>
							<span class="sm:hidden">
								{{ index + 1 }}
							</span>
						</button>
					</div>

					<div class="sm:flex justify-between items-center hidden gap-3">
						<button
							type="button"
							class="border transition-2 default-btn rounded-full flex-none w-[64px] h-[64px] flexed justify-center"
							:class="{
								'navigation-active': isLastItmeActive || currentTab > 0,
								'navigation-inactive': !isLastItmeActive && currentTab == 0
							}"
							aria-label="arrow-backward"
							@click="switchTab(false)"
						>
							<tools-icon dir="arrows" icon="arrow-backward" path-class="navigation" />
						</button>

						<button
							type="button"
							class="border transition-2 default-btn rounded-full flex-none w-[64px] h-[64px] flexed justify-center"
							:class="{
								'navigation-active': !isLastItmeActive,
								'navigation-inactive': isLastItmeActive
							}"
							aria-label="arrow-forward"
							@click="switchTab(true)"
						>
							<tools-icon dir="arrows" icon="arrow-forward" path-class="navigation" />
						</button>
					</div>
				</div>
			</div>

			<div class="mt-5 w-full flex-none">
				<div
					class="mt-10 flexed overflow-hidden md:overflow-x-hidden overflow-x-auto gap-x-2 md:gap-x-0 pb-5 invisible-scrollbar"
					ref="cardWrapper"
					id="cardWrapper"
				>
					<div
						v-for="(item, index) in processess"
						:key="item.label + index"
						class="lg:min-h-[510px] min-h-[400px] xs:min-h-[400px] overflow-hidden sm:min-w-[320px] lg:pt-24 pt-12 lg:pl-8 pl-3 lg:w-[1000px] rounded-[6px] md:rounded-[20px] snap-center w-full max-w-[320px] flex flex-wrap items-stretch sm:max-w-full flex-none bg-white relative dark:bg-gray-200 md:mr-3 last:mr-0"
						:data-index="item.title"
						:class="{
							highlightedCard: item.active
						}"
					>
						<div class="space-y-5">
							<strong class="font-semibold lg:text-[2em] text-xl text-gray-700">
								{{ item.title }}
							</strong>
							<p class="lg:text-xl text-base max-w-[410px] text-gray-700">
								{{ item.description }}
							</p>

							<button
								type="button"
								name="get started with onboarding"
								class="default-btn bg-main w-full py-4 max-w-[240px] justify-center text-white lg:flex group hidden translate-y-28 gap-x-2 custom-transition-2 hover:bg-base-primary"
								@click="$emit('trigger', item.label)"
							>
								Get Started
								<span class="group-hover:translate-x-2 custom-transition-3"
									><tools-icon dir="arrows" icon="arrow-short-r"
								/></span>
							</button>
						</div>

						<div class="inline-flex flex-1 relative -bottom-4 -right-7">
							<div
								class="lg:max-h-[380px] h-full max-w-[540px] mt-auto w-full max-h-[300px] flex items-center p-3 md:pl-5 md:pt-5"
								:class="item.bgClass"
							>
								<nuxt-img
									provider="cloudinary"
									:src="item.src"
									loading="lazy"
									:alt="item.label"
									class="w-full h-full object-cover object-left"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</ui-pad>
		<button type="button" class="default-btn sm:hidden bg-main text-white p-[18px_20px]" @click="$emit('trigger')">
			<span>Get Started</span>
			<tools-icon dir="arrows" icon="arrow-short-r" :width="16" />
		</button>
	</section>
</template>

<style scoped>
	.selected-btn {
		@apply border-transparent text-[#1A1200] bg-white;
	}
	.scroll-container {
		-webkit-overflow-scrolling: touch !important;
	}
	.navigation-active {
		@apply bg-main border-transparent;
	}

	.navigation-active :deep(.navigation) {
		@apply stroke-white;
	}

	.navigation-inactive {
		@apply bg-transparent border-gray-500;
	}

	.navigation-inactive :deep(.navigation) {
		@apply stroke-gray-500;
	}
</style>
